var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#fc9d19",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.03711,2c-0.15891,-0.00584 -0.31693,0.0263 -0.46094,0.09375l-22,10.28711c-0.35107,0.16431 -0.57559,0.51668 -0.57617,0.9043v1.71484c0.00006,0.55226 0.44774,0.99994 1,1h2c0,1.29975 0.83483,2.43211 2,2.83398v18.31641c-1.17197,0.38934 -2,1.54472 -2,2.84961v1h-0.1543c-1.60562,0 -2.8457,1.39721 -2.8457,3v3h46v-3c0,-1.60279 -1.24008,-3 -2.8457,-3h-0.1543v-1c0,-1.30489 -0.82803,-2.46027 -2,-2.84961v-18.31641c1.16517,-0.40187 2,-1.53423 2,-2.83398h2c0.55226,-0.00006 0.99994,-0.44774 1,-1v-1.71484c-0.00059,-0.38762 -0.2251,-0.73999 -0.57617,-0.9043l-22,-10.28711c-0.12133,-0.05684 -0.25283,-0.08872 -0.38672,-0.09375zM25,4.10352l21,9.81836v0.07813h-42v-0.07812zM7,16h36c0,0.5883 -0.4194,1 -0.9082,1h-20.0918h-4h-10.0918c-0.48881,0 -0.9082,-0.4117 -0.9082,-1zM9,19h2v18h-2zM13,19h4v18h-4zM19,19h2v18h-2zM23,19h4v18h-4zM29,19h2v18h-2zM33,19h4v18h-4zM39,19h2v18h-2zM7.8457,39h10.1543h4h20.1543c0.43438,0 0.8457,0.39479 0.8457,1v1h-36v-1c0,-0.60521 0.41132,-1 0.8457,-1zM4.8457,43h40.30859c0.43438,0 0.8457,0.39479 0.8457,1v1h-42v-1c0,-0.60521 0.41132,-1 0.8457,-1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.7bb53f2701b2a6e58a5710482ee02db8.svg";
export { ForwardRef as ReactComponent };